var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-modal',{attrs:{"active":_vm.visible,"has-modal-card":"","on-cancel":_vm.hideModal}},[_c(_vm.component,{tag:"component",attrs:{"title":_vm.modalTitle,"dataset":_vm.modalData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }